<template>
  <div>
    <FiltersTableAtenciones/>
    <TableAtenciones @estaDescargando="recibirValor"/>
    <AtencionModalView isAuditoria/>
    <AtencionAuditoriaComentarios/>
    <AtencionAuditoriaVerComentarios/>
    <AtencionValidacionComentario/>
    <AtencionModalUploads/> 

  </div>
</template>
<script>
import { BootstrapVue } from 'bootstrap-vue';
import { mapState } from 'vuex';
import axios from 'axios';
import actions from '@/assets/utils/utils';
import { comprobarPermisos } from "@/shared/helpers";


import FiltersTableAtenciones from '../components/TableAtenciones/FiltersTableAtenciones.vue';

import { 
  AtencionModalView,
  AtencionAuditoriaComentarios,
  AtencionAuditoriaVerComentarios,
  TableAtenciones,
  AtencionValidacionComentario,
  AtencionModalUploads,
} from '../components';

export default {
  components: {
    ...BootstrapVue.components,
    AtencionModalView,
    AtencionAuditoriaComentarios,
    AtencionAuditoriaVerComentarios,
    AtencionValidacionComentario,
    TableAtenciones,
    FiltersTableAtenciones,
    AtencionModalUploads,
  },

  props: {
    title: {
      type: String,
      default: ' Título predeterminado'
    },
  },

  data() {
    return {  
      descargando : false,
      itemAtencion: [],
    }
  },
  async created() {
    comprobarPermisos(this.$route);
    this.setToken();
  },

  async mounted() {
    actions.setearTitulo('Atenciones Medicas');
  },

  methods: {
    
    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'));
      this.login_user = user.username;
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`;
    },

    recibirValor(descargando){
      this.descargando = descargando
    },
  },
  
  computed: {
    ...mapState({
      stFiltros: state => state.atencionMedica.tableFilters
    }),
  },

}
</script>